import React from 'react';

function Article(props) {
  return (
    <article>
      <a href={'https://reddit.com' + props.article.permalink} target='_blank'>
        <h3>
          {' '}
          <i class='fas fa-city'></i> {props.article.title}
        </h3>
      </a>
    </article>
  );
}

export default Article;
